import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "toggleButton"]

  connect() {
    this.isOpen = false
  }

  toggle() {
    this.isOpen = !this.isOpen
    
    if (this.isOpen) {
      this.sidebarTarget.classList.add("!translate-x-0", "duration-300", "ease-linear")
      this.toggleButtonTarget.classList.add("!-right-9")
    } else {
      this.sidebarTarget.classList.remove("!translate-x-0", "duration-300", "ease-linear")
      this.toggleButtonTarget.classList.remove("!-right-9")
    }
  }
}
